import {gql} from "@apollo/client";
import {AssignmentErrorsData} from "../../../schema";

export type QueryData = {
  root: AssignmentErrorsData;
};

export const challengesErrorsQuery = gql`
  query MemberEditDropdownComponentQuery($userId: ID!) {
    root: getAssignmentErrorsData(userId: $userId) {
      challenges {
        id
        name
        alreadyAssigned
        activateAt
        deactivateAt
      }
      projects {
        id
        name
        alreadyAssigned
        challenges {
          id
          name
          alreadyAssigned
          activateAt
          deactivateAt
        }
      }
    }
  }
`;
